module.exports = __webpack_public_path__ + "static/img/banner_solutions_ic.e2a28b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_ic.png
// module id = sH/K
// module chunks = 10